import React, { Fragment } from 'react';
import Carousel from 'nuka-carousel';
import { BGBlue, BG, Nav as NavWrapper, MobilePromo } from './hero.css';
import Nav from '../nav/nav';

import LonelyHero from '../../../static/imlonely.jpg';
import LonelyHeroMobile from '../../../static/lonely-hero-mobile.jpg';
import HIFLogo from '../../../static/hif-logo.png';

// Icons
import Globe from '../../../static/globe.svg';
import USFlag from '../../../static/usa-flag.svg';
import Amazon from '../../../static/amazon-brands.svg';
import iTunes from '../../../static/itunes-note-brands.svg';
import Apple from '../../../static/apple-brands.svg';
import Spotify from '../../../static/spotify-brands.svg';
import MyBlueThoughts from '../../../static/mbt-logo.png';

const Hero = () => {
  return (
    <Fragment>
      <NavWrapper className="wrapper">
        <Nav />
      </NavWrapper>
      <Carousel
        wrapAround={true}
        renderCenterLeftControls={() => null}
        renderCenterRightControls={() => null}
        renderBottomCenterControls={() => null}
        autoplay={true}
        autoplayInterval={8000}
      >
        <BG
          song={LonelyHero}
          mobileBg={LonelyHeroMobile}
          bgColor="#eff1f1"
          name="lonely"
        >
          <div className="hifWrapper">
            <div className="promoPhoto" />
            <div className="promoLinks">
              <img src={HIFLogo} alt="How I Feel Logo" />
              <div className="avail">Available March 6th</div>

              <div className="orderWrapper">
                <div className="orderTitle">PHYSICAL PRE-ORDER</div>
                <div className="orderBtns">
                  <a
                    href="https://lauvpreorder.com"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img src={USFlag} alt="USA Pre-order" />
                    ALBUM PRE-ORDER US
                  </a>
                  <a
                    href="https://lauv.tmstor.es"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img src={Globe} alt="World Pre-order" />
                    ALBUM PRE-ORDER WORLD
                  </a>
                </div>
              </div>
              <div className="orderWrapper">
                <div className="orderTitle">Stream and Download</div>
                <div className="orderBtns">
                  <a
                    href="https://ffm.to/howimfeeling/spotify"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img src={Spotify} alt="Spotify Pre-order" />
                    Spotify Pre-Save
                  </a>
                  <a
                    href="https://lauv.lnk.to/hifpreadd"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img src={Apple} alt="Apple Pre-order" />
                    Apple Music Pre-Add
                  </a>
                </div>
                <div className="orderBtns">
                  <a
                    href="https://ffm.to/howimfeeling/itunes"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={iTunes} alt="iTunes Pre-order" />
                    iTunes Pre-Order
                  </a>
                  <a
                    href="https://ffm.to/howimfeeling/amazonstore"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={Amazon} alt="Amazon Pre-order" />
                    Amazon Pre-Order
                  </a>
                </div>
              </div>
            </div>
          </div>
        </BG>

        <BGBlue>
          <div className="hifWrapper">
            <img src={MyBlueThoughts} alt="My Blue Thoughts" />
            <div className="mbtTitle">EXPLORE THE NEW SITE</div>
            <a href="https://mybluethoughts.world" className="mbtExplore">
              Launch
            </a>
          </div>
        </BGBlue>
      </Carousel>
      <MobilePromo>
        <div className="orderWrapper">
          <div className="orderTitle">PHYSICAL PRE-ORDER</div>
          <div className="orderBtns">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://lauvpreorder.com"
            >
              ALBUM PRE-ORDER US
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://lauv.tmstor.es"
            >
              ALBUM PRE-ORDER WORLD
            </a>
          </div>
        </div>
        <div className="orderWrapper">
          <div className="orderTitle">Stream and Download</div>
          <div className="orderBtns">
            <a
              href="https://ffm.to/howimfeeling/spotify"
              rel="noopener noreferrer"
              target="_blank"
            >
              Spotify Pre-Save
            </a>
            <a
              href="https://ffm.to/howimfeeling/apple__direct"
              rel="noopener noreferrer"
              target="_blank"
            >
              Apple Music Pre-Add
            </a>
          </div>
          <div className="orderBtns">
            <a
              href="https://ffm.to/howimfeeling/itunes"
              target="_blank"
              rel="noopener noreferrer"
            >
              iTunes Pre-Order
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://ffm.to/howimfeeling/amazonstore"
            >
              Amazon Pre-Order
            </a>
          </div>
        </div>
      </MobilePromo>
    </Fragment>
  );
};

export default Hero;
